import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useAtom } from 'jotai'

import {
    CustomTabsWithPadding,
    CustomTab,
    CustomTabPanelSmall,
    CustomButtonTab,
} from '@/components/custom-tabs'
import useTabs from '@/hooks/use-tabs'
import CollectionYardDetails from '@/components/collection-yard/details'
import { useCollectionYards } from '@/hooks/api/use-collection-yard'
import { selectedMunicipalityIdAtom } from '@/state'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import CollectionYardForm from '@/components/forms/collection-yard'
import { UserRole } from '@/types'
import { getUserRole } from '@/helpers'
import MunicipalityPermissionGate from '../municipality-permission-gate'

function CollectionYardTabs() {

    const role = getUserRole()
    
    const { tab, handleTabChange, a11yProps } = useTabs()

    const [municipalityId] = useAtom(selectedMunicipalityIdAtom)
    
    const { status, data, error } = useCollectionYards(municipalityId)

    if (status === 'pending') {
        return (
            <LoadingBox />
        )
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={`Nepovedlo se načíst detaily poplatků za odpad pro obec s ID ${municipalityId}`}
        />
    }

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <CustomTabsWithPadding
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="waste fee tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {data.map((collectionYard, index) => (
                        <CustomTab key={collectionYard.id} label={collectionYard.name} {...a11yProps(index)} />
                    ))}
                    {(role === UserRole.admin || role === UserRole.municipalityOfficial || role === UserRole.collectionCompany) &&
                        <CustomButtonTab key="Přidat" label="+ Přidat" {...a11yProps(data.length)} />
                    }
                </CustomTabsWithPadding>
            </Box>
            {data.map((collectionYard, index) => (
                <CustomTabPanelSmall key={collectionYard.id} value={tab} index={index}>
                    <CollectionYardDetails collectionYard={collectionYard} />
                </CustomTabPanelSmall>
            ))}
            {(role === UserRole.admin || role === UserRole.municipalityOfficial || role === UserRole.collectionCompany) &&
                <CustomTabPanelSmall value={tab} index={data.length}>
                    <MunicipalityPermissionGate>
                        <Container maxWidth="lg">
                            <CollectionYardForm closeCallback={data.length > 0 ? () => {
                                handleTabChange(undefined, 0)
                            } : undefined}/>
                        </Container>
                    </MunicipalityPermissionGate>
                </CustomTabPanelSmall>
            }
        </>
    )
}

export default CollectionYardTabs
